jQuery(document).ready(function ($) {
    'use strict';
    var $items = $('.offer').clone();
    $('.single-category').on('click', function (e) {
        e.preventDefault();

        var $this = $(this);
        var $slides = $items;
        if ($this.data('id') !== 'show-all') {
            $slides = $slides.filter('[data-id*=' + $this.data('id') + ']');

        }

        $('.offers-container').empty().append($slides);

        $('.single-category').removeClass('active');
        $this.addClass('active');

        $('body').trigger('product-filter/apply');
    });
});
